import AppConstant from '../../../../config/app.constants';

class OnHoldController {
    /*@ngInject*/
    constructor($state, Modal, $translate, $q, User, DateUtil, SetupService, UsersService, UserBranchService,
                RouteService, ReportService, Navigation, DataCounter) {
        this.$state = $state;
        this.Modal = Modal;
        this.$translate = $translate;
        this.$q = $q;
        this.User = User;
        this.DateUtil = DateUtil;
        this.SetupService = SetupService;
        this.UsersService = UsersService;
        this.UserBranchService = UserBranchService;
        this.RouteService = RouteService;
        this.ReportService = ReportService;
        this.Navigation = Navigation;
        this.DataCounter = DataCounter;
        this.acl = {};
        this.hasACL = {};
        this.id = "on_hold";

        this.model = {
            onHoldReportObj: {
                loading: false,
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
            },
            routeListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            supervisorListObj: {
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                loading: false
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            },
            branch: User.getUser().branchId,
            loggedInUser: User.getUser().id,
            userBranchList: [],
            isExporting: false
        }

    }

    $onInit() {
        for (let key in this.acl['reporting_' + this.id]) {
            this.hasACL[this.acl['reporting_' + this.id][key]] = true;
        }

        this.model.loading = true;

        this.$q.all([
            this.SetupService.get(this.model.branch),
            this.UserBranchService.getUserBranches(this.model.loggedInUser),
        ])
            .then((data) => {
                this.model.setupDetails = data[0];
                this.model.userBranchList = data[1].results;
                this.model.vaultDate = this.DateUtil.convertToDate(this.model.setupDetails.currentVaultDate);

                this.model.userBranchList.filter((branch) => {
                    if (branch.branchId == this.model.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                });

                this.setDateRangeOptions('dateRangeOptions');
                this.model.dateRangeOptions.startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                this.model.dateRangeOptions.endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');

                this.search();
                this.getRouteList();
                this.loadSupervisors();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    setDateRangeOptions(modelValue) {
        this.model[modelValue] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.search();
                    //this.onHoldReport();
                }
            },
            ranges: {
                'Previous Week': [
                    moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Last 60 Days': [
                    moment().subtract('59', 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
            }
        };
    }

    getStartDate() {
        return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }

    getEndDate() {
        return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }

    getRouteList(searchKey, offset) {
        setTimeout(() => {
            searchKey = searchKey || '';

            const routeSearchObj = {
                queryJSON: {
                    rules: [
                        {
                            field: 'branchId',
                            condition: 'IN',
                            data: this.getSelectedBranches()
                        },
                        {
                            group: {
                                rules: [{
                                    field: 'id',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                },
                                {
                                    field: 'name',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                }
                                ],
                                operator: 'OR'
                            }
                        }
                    ],
                    operator: 'AND'
                }
            };

            this.model.routeListObj.loading = true;
            return this.RouteService.all(routeSearchObj, offset, AppConstant.defaultPageLimit)
                .then((data) => {
                    if (offset == 0 || offset === undefined) {
                        this.model.routeListObj.totalRecords = data.total;
                        this.model.routeListObj.results = this.routeDataMapping(data.results);
                    } else {
                        const routes = this.routeDataMapping(data.results);
                        this.model.routeListObj.results = this.model.routeListObj.results.concat(routes);
                    }
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.routeListObj.loading = false;
                })
        });
    }

    routeDataMapping(routes) {
        return routes.map((route) => {
            return {
                Key: route.name,
                Value: route.id
            }
        });
    }

    getSelectedBranches() {
        return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map((branch) => branch.branchId) : null;
    }

    loadSupervisors(searchKey, offset) {
        setTimeout(() => {
            this.model.supervisorListObj.loading = true;
            this.ReportService.userList(searchKey, this.getSelectedBranches(), offset,
                this.model.supervisorListObj.pagination.pageLimit)
                .then((data) => {
                    if (offset == 0 || offset === undefined) {
                        this.model.supervisorListObj.totalRecords = data.totalRecords;
                        this.model.supervisorListObj.results = this.mappingUserData(data.results);
                    } else {
                        const supervisorList = this.mappingUserData(data.results);
                         this.model.supervisorListObj.results =  this.model.supervisorListObj.results.concat(supervisorList);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.supervisorListObj.loading = false;
                })
        })
    }

    mappingUserData(users) {
        return users.map((user) => {
            return {
                Key: `${user.userId} | ${user.userName}`,
                Value: user.userId
            };
        });
    }

    onHoldReport() {
        setTimeout(() => {
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const routeId = this.model.routeId ? this.model.routeId.Value : null;
            const branches = this.model.selectedBranch.map((branchObj) => branchObj.branchId);
            const supvHoldId = this.model.supvHoldId ? this.model.supvHoldId.Value : null;

            this.model.onHoldReportObj.loading = true;
            this.ReportService.onHoldReport(this.model.searchText, startDate, endDate, routeId, branches, supvHoldId,
                (this.model.onHoldReportObj.pagination.page - 1) * this.model.onHoldReportObj.pagination.pageLimit,
                this.model.onHoldReportObj.pagination.pageLimit)
                .then((data) => {
                    this.model.onHoldReportObj.pagination.total = data.totalRecords;
                    this.model.onHoldReportObj.results = data.results;
                    this.model.onHoldReportObj.totalRecords = data.totalRecords;
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.onHoldReportObj.loading = false;
                })
        })
    }

    downloadFile(reportPrefix, reportData) {
        const fileName = reportPrefix.concat('.csv');
        const a = document.createElement("a");
        document.body.appendChild(a);
        const file = new Blob([reportData], { type: 'application/csv' });
        const fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
    }

    exportToCSV() {
        const startDate = this.getStartDate();
        const endDate = this.getEndDate();
        const routeId = this.model.routeId ? this.model.routeId.Value : null;
        const branches = this.model.selectedBranch.map((branchObj) => branchObj.branchId);

        const reportPrefix = `HOLD_Reports_(${moment(startDate).format('YYYY-MM-DD')}_${moment(endDate).format('YYYY-MM-DD')})`;

        this.model.isExporting = true;
        this.ReportService.exportHoldReport(this.model.searchText, startDate, endDate, routeId, branches)
            .then((data) => {
                this.downloadFile(reportPrefix, data.reportData)
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.model.isExporting = false;
            })
    }

    goToItemHistory(trackingId) {
        this.Navigation.goToItemHistory(trackingId, null);
    }

    pageChange() {
        this.onHoldReport();
    }

    search() {
        this.model.onHoldReportObj.pagination.page = 1;
        this.onHoldReport();
    }

    resetData() {
        this.model.routeId = null;
        this.model.supvHoldId = null;
        this.model.onHoldReportObj.pagination.page = 1;
    }

    goToServiceHistory(locationId) {
        const obj = {
          locationId: locationId,
          isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.locations');
      }
}

export default OnHoldController;



// WEBPACK FOOTER //
// ./client/app/components/reporting/components/on_hold/on_hold.controller.js